<template>
<div>
    <div class="container">
        <el-page-header class="page-header" @back="goBack" content="症状信息"></el-page-header>
        <AreaHeader class="area-header-one" title="基本信息"></AreaHeader>
        <ul class="basic-info" v-if="consultInfo && consultInfo.name">
            <li><b>姓名：</b>{{consultInfo.name}}</li>
            <li><b>性别：</b>{{consultInfo.sex == '1'?'男':'女'}}</li>
            <li><b>电话：</b>{{consultInfo.phoneNo}}</li>
            <li><b>出生日期：</b>{{consultInfo.birthday}}</li>
            <li><b>常住地址：</b>{{consultInfo.liveArea}}</li>
            <li><b>出生地址：</b>{{consultInfo.birthArea}}</li>
        </ul>
        <AreaHeader class="area-header" title="处方使用信息"></AreaHeader>
        <ul class="basic-info" v-if="consultInfo.useDate">
            <li><b>开始服药时间：</b>{{consultInfo.useDate}}</li>
            <li><b>服药天数：</b>{{consultInfo.useDays}}</li>
        </ul>
        <AreaHeader class="area-header" title="症状信息"></AreaHeader>
        <el-form label-width="120px" label-position="right" class="basic-info" v-if="submitData.basic_array && submitData.basic_enter_array">
            <WJTRadio
            v-model="submitData.basic_array[0].value"
            :label="submitData.basic_array[0].key+'：'"
            :must='submitData.basic_array[0].must'
            :disable='radioDisable'
            :radios='submitData.basic_array[0].options'>
            </WJTRadio>
            <div class="form--item-row">
                <el-form-item :label="submitData.basic_enter_array[0].key+'：'" class="form-item-half">
                    <el-input v-model="submitData.basic_enter_array[0].value" autocomplete="off" placeholder="请输入体温"></el-input>
                </el-form-item>
                <el-form-item :label="submitData.basic_enter_array[1].key+'：'" class="form-item-half form-item-right">
                    <el-input v-model="submitData.basic_enter_array[1].value" autocomplete="off" placeholder="请输入脉搏（次/分）"></el-input>
                </el-form-item>
            </div>
            <div class="form--item-row">
                <el-form-item :label="submitData.basic_enter_array[2].key+'：'" class="form-item-half">
                    <el-input v-model="submitData.basic_enter_array[2].value" autocomplete="off" placeholder="请输入血压-收缩压（mmHg)"></el-input>
                </el-form-item>
                <el-form-item :label="submitData.basic_enter_array[3].key+'：'" class="form-item-half form-item-right">
                    <el-input v-model="submitData.basic_enter_array[3].value" autocomplete="off" placeholder="请输入血压-舒张压（mmHg)"></el-input>
                </el-form-item>
            </div>
            <div class="form--item-row form-item-textarea">
                <el-form-item :label="submitData.basic_enter_array[4].key+'：'" class="form-item-half">
                    <el-input v-model="submitData.basic_enter_array[4].value" type="textarea" autocomplete="off" placeholder="请输入主诉"></el-input>
                </el-form-item>
                <el-form-item :label="submitData.basic_enter_array[5].key+'：'" class="form-item-half form-item-right">
                    <el-input v-model="submitData.basic_enter_array[5].value" type="textarea" autocomplete="off" placeholder="请输入西医诊断结果"></el-input>
                </el-form-item>
            </div>
        </el-form>
        <div class="divider"></div>
        <el-form label-width="120px" label-position="right" class="basic-info" v-if="submitData.basic_array && submitData.maixiang_array">
            <div class="form--item-row">
                 <WJTRadio
                    v-model="submitData.basic_array[1].value"
                    :label="submitData.basic_array[1].key+'：'"
                    :must='submitData.basic_array[1].must'
                    :radios='submitData.basic_array[1].options'
                    :defaultValue='submitData.basic_array[1].defaultValue'>
                </WJTRadio>
                <WJTRadio
                    v-model="submitData.basic_array[2].value"
                    :label="submitData.basic_array[2].key+'：'"
                    :must='submitData.basic_array[2].must'
                    :radios='submitData.basic_array[2].options'
                    :defaultValue='submitData.basic_array[2].defaultValue'>
                </WJTRadio>
            </div>
            <div class="form--item-row">
                 <WJTRadio
                    v-model="submitData.basic_array[3].value"
                    :label="submitData.basic_array[3].key+'：'"
                    :must='submitData.basic_array[3].must'
                    :radios='submitData.basic_array[3].options'
                    :defaultValue='submitData.basic_array[3].defaultValue'>
                </WJTRadio>
                <WJTRadio
                    v-model="submitData.basic_array[4].value"
                    :label="submitData.basic_array[4].key+'：'"
                    :must='submitData.basic_array[4].must'
                    :radios='submitData.basic_array[4].options'
                    :defaultValue='submitData.basic_array[4].defaultValue'>
                </WJTRadio>
            </div>
            <div class="form--item-row">
                 <WJTRadio
                    v-model="submitData.maixiang_array[0].value"
                    :label="submitData.maixiang_array[0].key+'：'"
                    :must='submitData.maixiang_array[0].must'
                    :radios='submitData.maixiang_array[0].options'
                    :defaultValue='submitData.maixiang_array[0].defaultValue'>
                </WJTRadio>
                <WJTRadio
                    v-model="submitData.maixiang_array[1].value"
                    :label="submitData.maixiang_array[1].key+'：'"
                    :must='submitData.maixiang_array[1].must'
                    :radios='submitData.maixiang_array[1].options'
                    :defaultValue='submitData.maixiang_array[1].defaultValue'>
                </WJTRadio>
            </div>
            <div class="form--item-row">
                 <WJTRadio
                    v-model="submitData.maixiang_array[2].value"
                    :label="submitData.maixiang_array[2].key+'：'"
                    :must='submitData.maixiang_array[2].must'
                    :radios='submitData.maixiang_array[2].options'
                    :defaultValue='submitData.maixiang_array[2].defaultValue'>
                </WJTRadio>
                <WJTRadio
                    v-model="submitData.maixiang_array[3].value"
                    :label="submitData.maixiang_array[3].key+'：'"
                    :must='submitData.maixiang_array[3].must'
                    :radios='submitData.maixiang_array[3].options'
                    :defaultValue='submitData.maixiang_array[3].defaultValue'>
                </WJTRadio>
            </div>
            <div class="form--item-row">
                 <WJTRadio
                    v-model="submitData.maixiang_array[4].value"
                    :label="submitData.maixiang_array[4].key+'：'"
                    :must='submitData.maixiang_array[4].must'
                    :radios='submitData.maixiang_array[4].options'
                    :defaultValue='submitData.maixiang_array[4].defaultValue'>
                </WJTRadio>
                <WJTRadio
                    v-model="submitData.maixiang_array[5].value"
                    :label="submitData.maixiang_array[5].key+'：'"
                    :must='submitData.maixiang_array[5].must'
                    :radios='submitData.maixiang_array[5].options'
                    :defaultValue='submitData.maixiang_array[5].defaultValue'>
                </WJTRadio>
            </div>
        </el-form>
        <AreaHeader class="area-header" title="三焦"></AreaHeader>
        <el-collapse class="collapse" v-model="activeNames">
            <el-collapse-item class="collapse-item" name="1" v-if="submitData.shangjiao_array">
                <template slot="title">
                    <div>
                        <span class="collapse-title">上焦</span>
                        <span class="collapse-hint">请选择上焦</span>
                    </div>
                </template>
                <div class="sanjiao-container">
                    <el-checkbox-group class="checkbox-group" v-model="shangjiao.value" v-for="shangjiao in submitData.shangjiao_array" :key="shangjiao.key">
                        <div class="group-label">
                            <span>{{shangjiao.key}}：</span>
                        </div>
                        <el-checkbox-button class="checkbox-button" v-for="option in shangjiao.options" :label="option" :key="option">{{option}}</el-checkbox-button>
                    </el-checkbox-group>
                </div>
            </el-collapse-item>
            <el-collapse-item class="collapse-item" name="2" v-if="submitData.zhongjiao_array">
                <template slot="title">
                    <div>
                       <span class="collapse-title">中焦</span>
                        <span class="collapse-hint">请选择中焦</span>
                    </div>
                </template>
                <div class="sanjiao-container">
                    <el-checkbox-group class="checkbox-group" v-model="zhongjiao.value" v-for="zhongjiao in submitData.zhongjiao_array" :key="zhongjiao.key">
                        <div class="group-label">
                            <span>{{zhongjiao.key}}：</span>
                        </div>
                        <el-checkbox-button class="checkbox-button" v-for="option in zhongjiao.options" :label="option" :key="option">{{option}}</el-checkbox-button>
                    </el-checkbox-group>
                </div>
            </el-collapse-item>
            <el-collapse-item class="collapse-item" name="3" v-if="submitData.xiajiao_array">
                <template slot="title">
                    <div>
                        <span class="collapse-title">下焦</span>
                        <span class="collapse-hint">请选择下焦</span>
                    </div>
                </template>
                <div class="sanjiao-container">
                    <el-checkbox-group class="checkbox-group" v-model="xiajiao.value" v-for="xiajiao in submitData.xiajiao_array" :key="xiajiao.key">
                        <div class="group-label">
                            <span>{{xiajiao.key}}：</span>
                        </div>
                        <el-checkbox-button class="checkbox-button" v-for="option in xiajiao.options" :label="option" :key="option">{{option}}</el-checkbox-button>
                    </el-checkbox-group>
                </div>
            </el-collapse-item>
        </el-collapse>
        <el-button class="btn-confirm" type="primary" @click="submit">{{mode == 1?'提交处方信息':'请输入药方'}}</el-button>
    </div>
</div>

</template>

<script>
import AreaHeader from '@/components/widgets/area-header.vue'
import WJTRadio from '@/components/widgets/wjt-radio.vue'
import form from '../../js/form'
export default {
    components:{
        AreaHeader,
        WJTRadio,
    },
    data () {
        return {
            consultInfo:{
              sex:"0",
              useDate:'',
              useDays:''
            },
            submitData: {},
            activeNames:'',
            radioDisable:false,
            mode:0,
        }
    },
    created (){
      this.mode = this.$route.query.mode
      var submitData = sessionStorage.getItem("submitData")

      if(this.utils.isEmptyStr(submitData)){
        for (var i=0;i<form.basic_array.length;i++) {
          if(i == 0){
            form.basic_array[i].value = '否'
          }else{
            form.basic_array[i].value = '正常'
          }
        }
        for (var i=0;i<form.basic_enter_array.length;i++) {
          form.basic_enter_array[i].value = ''
        }
        for (var i=0;i<form.maixiang_array.length;i++) {
          form.maixiang_array[i].value = '正常'
        }
        for (var i=0;i<form.shangjiao_array.length;i++) {
          form.shangjiao_array[i].value = []
        }
        for (var i=0;i<form.zhongjiao_array.length;i++) {
          form.zhongjiao_array[i].value = []
        }
        for (var i=0;i<form.xiajiao_array.length;i++) {
          form.xiajiao_array[i].value = []
        }
        this.submitData = form
        console.log(form)
      }else{
        this.submitData = JSON.parse(submitData)
      }
      var consult = JSON.parse(sessionStorage.getItem("consultInfo"))
      console.log("consultInfo:")
      console.log(consult)
      if(!this.utils.isEmptyObject(consult)){
          this.consultInfo = consult
          this.radioDisable = consult.sex == '1'?true:false
      }
    },
    methods:{
        goBack(){
            this.$router.go(-1)
        },
        submit(){
            // this.$store.commit("updateBasicArray",this.submitData.basic_array)
            // this.$store.commit("updateBasicEnterArray",this.submitData.basic_enter_array)
            // this.$store.commit("updateMaixiangArray",this.submitData.maixiang_array)
            // this.$store.commit("updateShangjiaoArray",this.submitData.shangjiao_array)
            // this.$store.commit("updateZhongjiaoArray",this.submitData.zhongjiao_array)
            // this.$store.commit("updateXiajiaoArray",this.submitData.xiajiao_array)
            sessionStorage.setItem("submitData",JSON.stringify(this.submitData))
            this.$router.push(this.mode == 1?"/prescriptionResult":'/handmadePrescription')
        }
    }
}
</script>

<style scoped>
.container{
    width: 1160px;
    margin: auto auto;
}
.page-header{
    width: 1080px;
    margin-top: 30px;
    color: #333333;
    font-size: 20px;
}
.page-header >>> div{
    color:#333333;
    font-size: 20px;
}
.area-header-one{
    margin-top: 35px;
}
.basic-info{
    width: 985px;
    margin-top: 30px;
    margin-bottom: 15px;
}
.sanjiao-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    overflow-x: auto;
}
.group-label{
    width: 140px;
    text-align: right;
    height: 40px;
}
.group-label>span{
    font-size: 18px;
    color: #333333;
    width: 100%;
    position: relative;
    top:15px;
}
  .table-rows>td{
      height: 50px;
      background: white;
      font-size: 18px;
  }
.checkbox-group{
    align-items: flex-start;
    display: flex;
    flex-direction: row;
}
.checkbox-button{
    margin: 10px 8px;
}
.basic-info>li{
    color: #333333;
    font-size: 18px;
    text-align: left;
    line-height: 40px;
}
.basic-info>li>b{
    font-weight: bold;
}
.form--item-row{
    display: flex;
    flex-direction: row;
    align-items: center;
}
.form-item-half{
    width: 50%;
}

.form-item-right{
    margin-left: 135px;
}
.form-bias{
    font-size: 18px;
    margin: 0 20px;
}
.form-item-textarea{
    margin-top: 10px;
}
.divider{
    height: 1px;
    background: #eeeeee;
    width: 100%;
}
.maixiang-container{
    display: flex;
    width: 100%;
    height: auto;
    flex-direction: column;
    align-items: center;
}
.btn-confirm{
    width: 384px;
    border-radius: 40px;
    margin-top: 60px;
    margin-bottom: 60px;
    font-size: 18px;
    height: 45px;
}
.collapse-item{
    margin-top: 50px;
}
.collapse{
    width: 1050px;
    margin-left: 30px;
}
.collapse-title{
    font-weight: bold;
    font-size: 18px;
    color: #333333;
}
.collapse-hint{
    font-size: 16px;
    color: #cecece;
    position: relative;
    left: 350px;
}
.is-disabled{
  background-color: #156098 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/kaifang/prescriptionInfo.vue